import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import ReusableTextBox from '../../../SharedComponents/Textbox/Textbox'
import Loading from '../../../Images/loading.gif'
import '../../../CSS/global.css'
import './DashboardAdminManageUser.css'
import { destroySession } from '../../../Utility/Utility';
import * as DashboardAdminManageUserConstant from './DashboardAdminManageUserConstant'
import { IoIosClose, IoMdSearch } from "react-icons/io";
import { isIE } from 'react-device-detect';
import ReactPaginate from 'react-paginate'
import { CleanersAdminSearchUser } from '../../../CleanersDashboardAdminAPI/CleanersAdminSearchUserApi'
import { CleanersAdminUpdateUser } from '../../../CleanersDashboardAdminAPI/CleanersAdminUpdateUserAPI'
import { CleanersAdminGetAllusers } from '../../../CleanersDashboardAdminAPI/CleanersAdminGetAllUsersAPI'
import Modal from 'react-modal';
import { FaRegEdit } from "react-icons/fa";
import { IconContext } from "react-icons";
import DashboardCleanersAdminHeader from '../../../CleanersDashboardComponents/Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
const $ = require('jquery')



class DashboardAdminManageUser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            redirectError400: false,
            redirectError401: false,
            redirectError404: false,
            redirectError500: false,
            searchUser: "",
            // SearhUserEmpty: false,
            modalIsOpen: false,
            EmailPolicy: false,
            arrayManageUserUpdated: [],
            VendorName: '',
            Email: "",
            Role: '',
            Status: "",
            InvalidVendor: false,
            selectRole: false,
            selectStatus: false,
            arrayvendorUsersList: [],
            Page: "1",
            pageCount: '',
            DisableRoleDropdown : false,
            Ie: false
        }
        this.handleChangeStore = this.handleChangeStore.bind(this);
        this.handleKeyPressStore = this.handleKeyPressStore.bind(this);
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.loadUsers = this.loadUsers.bind(this);
        this.loadUserTable = true


    }
    componentWillMount() {
        if (isIE) {
            this.setState({
                Ie: true
            })
        }
        let UserID = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const Token = 'bearer '.concat(TokenDataApi);
        let PageOnLoad = "1"
        this.loadUsers(UserID, Token, PageOnLoad);
    }
    loadUsers(UserID, Token, Pages) {
        this.loadUserTable = true
        this.setState({
            loading: true
        })
        let UserId = UserID
        let Page = Pages
        const AuthStr = Token
        let arrayvendorUsersList = []
        if (this.loadUserTable) {
            CleanersAdminGetAllusers(UserId, AuthStr, Page).then(res => {
                if (res.status == 200) {
                    this.setState({
                        loading: false
                    })
                    let vendorUsersList = res.data.vendorUsersList.vendorUsersList
                    let pageCount = res.data.vendorUsersList.pageCount
                    this.setState({
                        pageCount: pageCount
                    })
                    Object.keys(vendorUsersList).forEach(function (key) {
                        arrayvendorUsersList.push({
                            Name: vendorUsersList[key].name,
                            Email: vendorUsersList[key].email,
                            Role: vendorUsersList[key].role,
                            Status: vendorUsersList[key].status
                        })
                    })
                    arrayvendorUsersList.map((x) => {
                        if (x.Role == 1) {
                            x.Role = "Admin"
                        }
                        if (x.Role == 2) {
                            x.Role = "View"
                        }
                        if (x.Role == 3) {
                            x.Role = "Super Admin"
                        }
                        if (x.Status == 1) {
                            x.Status = "Active"
                        }
                        if (x.Status == 0) {
                            x.Status = "Inactive"
                        }
                    })
                    this.setState({
                        arrayvendorUsersList: arrayvendorUsersList
                    })

                    if (vendorUsersList.length == 0) {
                        this.setState({
                            NoData: true
                        })
                    }
                }
                else if (res.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (res.status == 401) {
                    // this.setState({
                    //     redirectError401: true,
                    //     loading: false
                    // })
                }
                else if (res.status == 404) {
                    this.setState({
                        redirectError404: true,
                        loading: false
                    })
                }

                else if (res.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }
            })
        }
    }

    openModal() {
        this.setState({
            modalIsOpen: true,
            selectRole: false,
            selectStatus: false
        })
    }

    afterOpenModal() {


    }

    closeModal() {
        this.setState({
            modalIsOpen: false
        });
    }
    handleChangeStore = (e) => {
        this.setState({
            searchUser: e.target.value,
            // SearhUserEmpty: false,
            EmailPolicy: false,
            InvalidVendor: false
        })
    }
    handleUserRole = (e) => {
        this.setState({
            Role: e.target.value,
            selectRole: false
        })
    }

    handleStatus = (e) => {
        this.setState({
            Status: e.target.value,
            selectStatus: false
        })
    }
    handlePageChange = (e) => {
        this.setState({
            loading: true
        })
        let selected = e.selected + 1
        this.setState({
            Page: selected
        })
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token')
        const Token = 'bearer '.concat(TokenDataApi);
        let Page = selected
        this.loadUsers(UserId, Token, Page)
    }
    handleSearchUser = (e) => {
        var Regex = /\S+@\S+\.\S+/;
        var Cond = Regex.test(this.state.searchUser)
        var apiFlag = true
        let Email = this.state.searchUser
        if (Email.length == "") {
            // this.setState({
            //     loadUserTable : true
            // })
            let UserID = sessionStorage.getItem('userId')
            let TokenDataApi = sessionStorage.getItem('token');
            const Token = 'bearer '.concat(TokenDataApi);
            let PageOnLoad = "1"
            this.loadUsers(UserID, Token, PageOnLoad);
            Cond = true
            apiFlag = false
        }
        if (!(Cond)) {
            this.setState({
                EmailPolicy: true
            })
            apiFlag = false
        }
        if (apiFlag) {
            this.setState({
                loading: true
                // loadUserTable : false
            })
            this.loadUserTable = false
            let arrayManageUser = []
            let UserId = sessionStorage.getItem('userId')
            let TokenDataApi = sessionStorage.getItem('token');
            const AuthStr = 'bearer '.concat(TokenDataApi);
            CleanersAdminSearchUser(UserId, AuthStr, Email).then(res => {
                if (res.status == 200) {
                    this.setState({
                        loading: false
                    })
                    let UserArray = res.data.user
                    arrayManageUser.push({
                        VendorName: UserArray.name,
                        Email: UserArray.email,
                        Role: UserArray.role,
                        Status: UserArray.status
                    })
                    arrayManageUser.map((x) => {
                        if (x.Role == 2) {
                            x.Role = "View"
                            this.setState({
                                Role: x.Role
                            })
                        }
                        if (x.Role == 1) {
                            x.Role = "Admin"
                            this.setState({
                                Role: x.Role
                            })
                        }
                        if (x.Role == 3) {
                            x.Role = "Super Admin"
                            this.setState({
                                Role: x.Role
                            })
                        }
                        if (x.Status == "True") {
                            x.Status = "Active"
                            this.setState({
                                Status: x.Status
                            })
                        }
                        if (x.Status == "False") {
                            x.Status = "Inactive"
                            this.setState({
                                Status: x.Status
                            })
                        }
                        
                    })
                 
                    this.setState({
                        arrayManageUserUpdated: arrayManageUser
                    })
                    this.state.arrayManageUserUpdated.map((x) => {
                        if(x.Email.split("@")[1] == "coop.co.uk") {
                            this.setState({
                                DisableRoleDropdown : true
                            }) 
                        }
                        else {
                            this.setState({
                                DisableRoleDropdown : false
                            }) 
                        }
                       
                    })

                }
                else if (res.status == 400) {
                    this.setState({
                        redirectError400: true,
                        loading: false
                    })
                }
                else if (res.status == 401) {
                    this.setState({
                        redirectError401: true,
                        loading: false
                    })
                }
                else if (res.status == 404) {
                    if (res.data.description = "Invalid VendorEmail") {
                        this.setState({
                            InvalidVendor: true,
                            loading: false
                        })
                    }
                    else {
                        this.setState({
                            redirectError404: true,
                            loading: false
                        })
                    }

                }

                else if (res.status == 500) {
                    this.setState({
                        redirectError500: true,
                        loading: false
                    })
                }
            })
        }

    }
    handleSaveUser = (e) => {
        let AuthData = {
            Name: this.state.VendorName,
            Email: this.state.Email,
            Role: this.state.Role,
            Status: this.state.Status
        }
        var apiFlag = true
        if (AuthData.Role == "Admin") {
            AuthData.Role = 1
        }
        if (AuthData.Role == "View") {
            AuthData.Role = 2
        }
        if(this.state.DisableRoleDropdown) {
             AuthData = {
                Name: this.state.VendorName,
                Email: this.state.Email,
                Status: this.state.Status
            }
        }
        let UserId = sessionStorage.getItem('userId')
        let TokenDataApi = sessionStorage.getItem('token');
        const AuthStr = 'bearer '.concat(TokenDataApi);
        this.setState({
            loading: true
        })
        CleanersAdminUpdateUser(AuthData, UserId, AuthStr).then(res => {
            if (res.status == 200) {
                this.setState({
                    loading: true,
                    modalIsOpen: false
                })
                this.handleSearchUser();
            }
            else if (res.status == 400) {
                this.setState({
                    redirectError400: true,
                    loading: false
                })
            }
            else if (res.status == 401) {
                this.setState({
                    redirectError401: true,
                    loading: false
                })
            }
            else if (res.status == 404) {
                this.setState({
                    redirectError404: true,
                    loading: false
                })
            }

            else if (res.status == 500) {
                this.setState({
                    redirectError500: true,
                    loading: false
                })
            }

        })


    }
    handleEditUser = (VendorName, Email, Role, Status) => {
        this.setState({
            VendorName: VendorName,
            Email: Email,
            Role: Role,
            Status: Status
        })
        if (this.state.Role == "Admin") {
            $(document).ready(function () {
                var num = "1";
                $("#StoreDefault option").each(function () {
                    if ($(this).val() == num) {
                        $(this).attr("selected", "selected");

                    }
                });
            });
        }
        else {
            $(document).ready(function () {
                var num = "2";
                $("#StoreDefault option").each(function () {
                    if ($(this).val() == num) {
                        $(this).attr("selected", "selected");

                    }
                });
            });
        }
        if (this.state.Status == "Active") {
            $(document).ready(function () {
                var num = "Active";
                $("#SupplierDefault option").each(function () {
                    if ($(this).val() == num) {
                        $(this).attr("selected", "selected");

                    }
                });
            });
        }
        else {
            $(document).ready(function () {
                var num = "Inactive";
                $("#SupplierDefault option").each(function () {
                    if ($(this).val() == num) {
                        $(this).attr("selected", "selected");

                    }
                });
            });
        }
        this.openModal();
    }
    handleKeyPressStore(e) {
        if (e.key == 'Enter') {
            this.handleSearchUser();
        }
    }
    render() {
        if (this.state.redirectLogin) {
            return (<Redirect to={'/DashboardLogin'} />)
        }
        if (this.state.redirectError400) {
            return (<Redirect to={'/CleanersAdminDashboardError400'} />)
        }
        if (this.state.redirectError401) {
            return (<Redirect to={'/CleanersAdminDashboardError401'} />)
        }
        if (this.state.redirectError404) {
            return (<Redirect to={'/CleanersAdminDashboardError404'} />)
        }
        if (this.state.redirectError500) {
            return (<Redirect to={'/CleanersAdminDashboardError500'} />)
        }
        return (
            <div>
                <DashboardCleanersAdminHeader />
                {this.state.loading ?
                    <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
                    <div className= "Manage">
                <div className="ModifUser">
                    <h3>{DashboardAdminManageUserConstant.SearchUser}</h3>
                    <p>{DashboardAdminManageUserConstant.EnterVendorEmail}</p>
                    {this.state.Ie ?
                    <ReusableTextBox className="StoreIdFieldManage" type="" onKeyPress={this.handleKeyPressStore} onChange={this.handleChangeStore} placeholder={DashboardAdminManageUserConstant.VendorEmail}></ReusableTextBox>
                     :
                    <ReusableTextBox className="StoreIdFieldManage" type="text" onKeyPress={this.handleKeyPressStore} onChange={this.handleChangeStore} placeholder={DashboardAdminManageUserConstant.VendorEmail}></ReusableTextBox>
                    }
                    {/* {this.state.SearhUserEmpty ? <span className="errorSearchUser">{DashboardAdminManageUserConstant.VendorEmailID} </span> : null} */}
                    {this.state.EmailPolicy ? <span className="errorSearchUser">{DashboardAdminManageUserConstant.EmailValid} </span> : null}
                    {this.state.InvalidVendor ? <span className="errorSearchUser">{DashboardAdminManageUserConstant.Invalid} </span> : null}
                    <div>
                        <IconContext.Provider
                            value={{ className: "global-class-name_searchStore" }}
                        >
                          {this.state.Ie ?
                                <IoMdSearch onClick={this.handleSearchUser} className="searchiconStoreIE" />
                                :
                            <IoMdSearch className="searchiconStore" onClick={this.handleSearchUser} />}
                        </IconContext.Provider>
                    </div>
                </div>

                <div className="User">
                    {this.loadUserTable ?

                        <div className="CompaniesUser">
                            <table className="CompaniesDataUser">
                                <thead>
                                    <tr>
                                        <th>{DashboardAdminManageUserConstant.VendorName}</th>
                                        <th>{DashboardAdminManageUserConstant.Email}</th>
                                        <th>{DashboardAdminManageUserConstant.Role}</th>
                                        <th>{DashboardAdminManageUserConstant.Status}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.arrayvendorUsersList.map((x, key) =>
                                        <tr key={key}>
                                            <td>{x.Name}</td>
                                            <td>{x.Email}</td>
                                            <td>{x.Role}</td>
                                            <td>{x.Status}</td>
                                        </tr>
                                    )}
                                    {this.state.NoData ?
                                        <tr>
                                            <td colspan="4">{DashboardAdminManageUserConstant.NoDataAvailable}</td></tr> : null
                                    }
                                </tbody>
                            </table>
                            <div className="ReactPaginate">
                                <ReactPaginate
                                    previousLabel={'Prev'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={this.state.pageCount}
                                    onPageChange={this.handlePageChange}
                                    marginPagesDisplayed={3}
                                    pageRangeDisplayed={3}
                                    containerClassName={'pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'paginationLink'}
                                    forcePage={this.state.Page - 1}
                                />
                            </div>
                        </div> :
                        <table className="UserData">
                            <thead>
                                <tr>
                                    <th>{DashboardAdminManageUserConstant.VendorName}</th>
                                    <th>{DashboardAdminManageUserConstant.Email}</th>
                                    <th>{DashboardAdminManageUserConstant.Role}</th>
                                    <th>{DashboardAdminManageUserConstant.Status}</th>
                                    <th>{DashboardAdminManageUserConstant.Action}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.arrayManageUserUpdated.map((x, key) =>
                                    <tr key={key}>
                                        <td>{x.VendorName}</td>
                                        <td>{x.Email}</td>
                                        <td>{x.Role}</td>
                                        <td>{x.Status}</td>
                                        <td><FaRegEdit className="EditIcon" onClick={(a, b, c) => this.handleEditUser(x.VendorName, x.Email, x.Role, x.Status)} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    }


                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeModal}
                        className="ModalNewUser"
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                    >
                        <div className="IconModal"> <IconContext.Provider
                            value={{ color: 'grey' }}
                        >
                            <IoIosClose onClick={this.closeModal} />
                        </IconContext.Provider>
                        </div>
                        <div className="ModalHead">
                            <p className="Mandotory">   <span className="mandatoryField">*</span>{DashboardAdminManageUserConstant.Mandatory}</p>
                            <h3>{DashboardAdminManageUserConstant.EditUserDetails}</h3>
                            <div className="DropdownsUser">
                            {this.state.DisableRoleDropdown ? null : 
                                <div className="DropdownUserRole">
                                    <p>{DashboardAdminManageUserConstant.UserRole}
                                        <span className="mandatoryField">*</span></p>
                                    {this.state.selectRole ? <span className="errorSearchUser">{DashboardAdminManageUserConstant.RoleEmpty} </span> : null}
                                
                                    <select className="UserRoleSelect" onChange={this.handleUserRole} id="StoreDefault">
                                        <option className="HeaderOption" value="1">{DashboardAdminManageUserConstant.Admin}</option>
                                        <option className="HeaderOption" value="2">{DashboardAdminManageUserConstant.View}</option>
                                    </select> 
                                </div>}
                                <div className="DropdownStatus">
                                    <p className="StatusPara">{DashboardAdminManageUserConstant.Status}
                                        <span className="mandatoryField">*</span></p>
                                    {this.state.selectStatus ? <span className="errorSearchUser">{DashboardAdminManageUserConstant.StatusEmpty} </span> : null}
                                    <select className="StatusSelect" onChange={this.handleStatus} id="SupplierDefault">
                                        <option className="HeaderOption" value="Inactive">{DashboardAdminManageUserConstant.InActive}</option>
                                        <option className="HeaderOption" value="Active">{DashboardAdminManageUserConstant.Active}</option>
                                        {/* {this.state.arraySuppliername.map((x, key) =>
                                            <option id={key} className="HeaderOption" value={x.SupplierName} key={key}>{x.SupplierName}</option>
                                        )} */}
                                    </select>
                                </div>
                            </div>
                            <div className="ButtonsEditUser">
                                <p className="CancelModal" onClick={this.closeModal}>{DashboardAdminManageUserConstant.Cancel}</p>
                                <ReusableButton className="SaveFieldModal" buttonText="Save" onClick={this.handleSaveUser} />
                            </div>
                        </div>
                    </Modal>
                </div>


</div>

            </div>
        )
    }
}

export default DashboardAdminManageUser;
